import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, fileUrl } from "../lib/api";
import BlockRenderer from "../components/BlockRenderer";
import SEO from "../components/SEO";

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setError("not_found"));
  }, [slug]);

  if (error) return (
    <div className="max-w-3xl mx-auto px-6 py-32 text-center">
      <SEO title="Post not found" path={`/blog/${slug}`} noIndex />
      <h1 className="font-serif-display text-5xl mb-4">Post not found</h1>
      <Link to="/blog" className="btn-primary-burgundy">Back to blog</Link>
    </div>
  );
  if (!post) return <div className="py-32 text-center text-neutral-500">Loading…</div>;

  return (
    <article className="fade-in" data-testid="blog-post-page">
      <SEO
        title={post.title}
        description={post.excerpt}
        path={`/blog/${post.slug}`}
        type="article"
        image={post.cover_image ? `${(typeof window !== "undefined" ? window.location.origin : "https://spiritandassociates.org")}${fileUrl(post.cover_image)}` : undefined}
        publishedTime={post.created_at}
        modifiedTime={post.updated_at}
      />
      <header className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 pt-24 pb-10">
        <Link to="/blog" className="label-eyebrow text-[#6B1F2A] hover:opacity-70 mb-6 inline-block">← Back to blog</Link>
        <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mb-4 text-[#1a1a1a]" data-testid="post-title">{post.title}</h1>
        <p className="text-sm text-neutral-500 tracking-wider">{new Date(post.created_at).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })} · {post.author}</p>
      </header>
      {post.cover_image && (
        <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 mb-12">
          <img src={fileUrl(post.cover_image)} alt={post.title} className="w-full aspect-[16/9] object-cover" />
        </div>
      )}
      <BlockRenderer blocks={post.blocks || []} />
      <div className="h-16" />
    </article>
  );
}
